import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from "./crud.service";
import {SmartlinkPreviewData} from '../_models';

@Injectable()
export class CampaignDomainService extends CrudService {
  constructor(protected http: HttpClient) {
    super(http, 'custom_domains');
  }

  verify(id: string | number) {
    return this.http.post(this.route + '/' + id.toString() + '/verify/', {});
  }

  startSession(id: string | number, data: {}) {
    return this.http.post(this.route + '/' + id.toString() + '/start_session/', data);
  }

  clearSmartlinkPreviewData(id: string | number) {
    sessionStorage.removeItem('smartlink_domain_' + id.toString());
  }

  getSmartlinkPreviewData(id: string | number) {
    const value = sessionStorage.getItem('smartlink_domain_' + id.toString());
    return value ? JSON.parse(value) : null;
  }

  setSmartlinkPreviewData(id: string | number, data: SmartlinkPreviewData) {
    sessionStorage.setItem('smartlink_domain_' + id.toString(), JSON.stringify(data));
  }
}
